import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const Mapping: AppRouteRecordRaw = {
  path: "/",
  name: "Mapping",
  redirect: "/mapping",
  component: LAYOUT,
  meta: {
    title: "商品映射管理",
  },

  children: [
    {
      path: "mapping",
      name: "AllianceMapping",
      component: () => import("@/views/alliance/mapping/index.vue"),
      meta: {
        title: "商品映射管理",
      },
      children: [
        {
          path: "import",
          name: "AllianceMappingImport",
          component: () => import("@/views/alliance/mapping-import/index.vue"),
          meta: {
            title: "批量导入商品映射",
            activeMenu: "/mapping",
          },
        },
      ],
    },
  ],
};

export default Mapping;
